import React, { useState } from 'react';
import { ReplyAll } from '@mui/icons-material';

import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';

import { getTranslateByKey } from '@/main/services/utils';

import * as S from '../styles';
import ModalConfirmRequotePart from './modalConfirmRequote/modalConfirmRequote';
import { RefreshQuoteByGetItemsType, TypeBoxCart } from './types';
import { RequoteQuoteItemRequest } from '@/main/models/request';
import { CartState } from '@/main/store/cart';
import WrapperModalRequoteSignalR from './modalRequoteSignalR/modalRequoteSignalR';
interface IButtonRequotePartProps {
  part: RequoteQuoteItemRequest;
  idButtonRequotePart: string;
  type?: TypeBoxCart;
  isQuoteCanceled: boolean;
  isQuoteBlocked: boolean;
  dataCart: CartState;
  isRequotePartCanceled?: boolean;
  refreshQuoteByGetItems: RefreshQuoteByGetItemsType;
  callbackAfterRemovePart?: (hasLastPartInCart: boolean) => void;
}
function ButtonRequotePart({
  part,
  idButtonRequotePart,
  dataCart,
  type = 'unaswered',
  isRequotePartCanceled = false,
  refreshQuoteByGetItems,
  callbackAfterRemovePart = () => { }
}: IButtonRequotePartProps) {
  const [openModalConfirm, setOpenModalConfirm] = useState<boolean>(false);
  const [openModalSignalR, setOpenModalSignalR] = useState<boolean>(false);


  function handleButtonRequotePart(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();
    setOpenModalConfirm(true);
  }

  return (
    <>
      <TooltipComponent
        title={getTranslateByKey('information.requoteParts')}
        placement="top"
      >
        <S.IconButtonClose
          onClick={handleButtonRequotePart}
          disabled={false}>
          <ReplyAll
            id={idButtonRequotePart}
            fontSize="small"
          />
        </S.IconButtonClose>
      </TooltipComponent>
      <ModalConfirmRequotePart
        type={type}
        dataCart={dataCart}
        isRequotePartCanceled={isRequotePartCanceled}
        partSelected={[part]}
        refreshQuoteByGetItems={refreshQuoteByGetItems}
        openModalConfirm={openModalConfirm}
        setOpenModalConfirm={setOpenModalConfirm}
        callbackAfterRemovePart={callbackAfterRemovePart}
        hasReason={true}
        callbackAfterRequotePart={() => { setOpenModalSignalR(true) }}
      />

      <WrapperModalRequoteSignalR
        claimNumber={''}
        closeModal={() => { setOpenModalSignalR(false) }}
        isOpenModal={openModalSignalR}
        setIsOpenModal={setOpenModalSignalR}
      />
    </>
  )
}

export default ButtonRequotePart